<template>
  <div>
    <!--选择身份-->
    <Modal v-model="modalStatus" width="24%" :mask-closable="false">
      <div slot="close" class="close-btn">
        <Icon
          type="close-round"
          @click="handleClose"
          color="#5c6b77"
          size="15"
        ></Icon>
      </div>
      <div class="subject-header">选择身份</div>
      <Form ref="subjectForm" :model="subjectParams" :rules="subjectRuleInline">
        <!-- {{ subjectParams.subjectId }} -->
        <FormItem prop="subjectId" v-if="entSysUserList.length">
          <RadioGroup v-model="subjectParams.subjectId">
            <div>
              <!-- <span>企业：</span> -->
              <Radio
                v-for="(item, index) in entSysUserList"
                :key="index"
                :label="item.id"
                >{{ item.businessName }}</Radio
              >
            </div>
          </RadioGroup>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="handleSubmit" class="subject-btn" long
          >确认</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: {
    entSysUserList: {
      type: Array,
      default: () => {
        [];
      },
    },
  },
  data() {
    return {
      modalStatus: false,
      //登录信息
      subjectParams: {
        subjectId: "",
      },
      //登录校验
      subjectRuleInline: {},
    };
  },
  methods: {
    handleClose() {
      this.modalStatus = false;
      this.$refs["subjectForm"].resetFields();
    },

    handleSubmit() {
      this.$refs["subjectForm"].validate((valid) => {
        if (valid) {
          let item = this.entSysUserList.find(
            (x) => x.id == this.subjectParams.subjectId
          );
          // this.$emit("getUserType", "2");
          localStorage.setItem("userType", "2");
          this.$store.dispatch("setUserInfo", item);
          localStorage.setItem("userInfo", JSON.stringify(item));
          this.modalStatus = false;
          this.$Modal.success({
            title: "提示",
            content: "企业账号登录成功",
            onOk: () => {
              this.$router.replace({
                path: "/index/HomePage",
              });
            },
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.subject-header {
  height: 98px;
  line-height: 98px;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/ModalSubject.vue